import React from "react";
import InterestValue from "visual-components/brandProfile/interests/interest-value";
import { formatRange } from "visual-components/brandProfile/opportunities/formatRange";
import OpportunityInfoCard from "./opportunity-info-card";

class ContentSwapOpportunityInfo extends React.Component {
  concatAges = (prop) => {
    let ageMap = {
      age_0_18: "0-18",
      age_18_24: "18-24",
      age_25_34: "25-34",
      age_35_44: "35-44",
      age_45_54: "45-54",
      age_55_up: "55+",
    };

    return Object.keys(ageMap)
      .filter((age) => prop[age])
      .map((age) => ageMap[age])
      .join(", ");
  };

  render() {
    let { opportunity, brand, showPen, obscure } = this.props;

    return (
      <OpportunityInfoCard tags={brand.tags} showPen={showPen}>
        <InterestValue
          title={"Swaps/Month"}
          value={formatRange(opportunity.min_swaps_per_month, opportunity.max_swaps_per_month)}
          marginRight="129px"
          obscure={obscure}
        />
        <InterestValue
          title={"Average Clicks/Article"}
          value={opportunity.average_clicks}
          marginRight="99px"
          obscure={obscure}
        />
        <InterestValue title={"Audience Gender"} value={opportunity.gender} obscure={obscure} />
        <div>
          <InterestValue
            title={"Age Range"}
            value={this.concatAges(opportunity)}
            obscure={obscure}
          />
        </div>
      </OpportunityInfoCard>
    );
  }
}

export default ContentSwapOpportunityInfo;
